/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIncreaseV1AccountNumberEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_INCREASE_V1_ACCOUNT_NUMBER_EVENT_ENTITY_NAME = 'exc.increase.v1.AccountNumberEvent';
export const excIncreaseV1AccountNumberEventEntity = new schema.Entity<ExcIncreaseV1AccountNumberEvent>(EXC_INCREASE_V1_ACCOUNT_NUMBER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcIncreaseV1AccountNumberEvent) => `${entity.metadata?.eventId}` });

